import {
  DateRangeOptions,
  PayoutCommissionsSortTypes,
  PaymentStatus,
} from '../typings';
import {
  DesktopDateRangePickerSlotProps,
  MobileDateRangePickerSlotProps,
} from '@mui/x-date-pickers-pro';
import { Dayjs } from 'dayjs';

export const commissionSortOptions = [
  {
    name: 'Newest first',
    value: PayoutCommissionsSortTypes.newest_first,
  },
  {
    name: 'Oldest first',
    value: PayoutCommissionsSortTypes.oldest_first,
  },
];

export const commissionPaymentStatusOptions = [
  {
    name: 'Paid',
    value: PaymentStatus.PAID,
  },
  {
    name: 'Processing',
    value: PaymentStatus.PROCESSING,
  },
  {
    name: 'Under Review',
    value: PaymentStatus.UNDER_REVIEW,
  },
  {
    name: 'Failed',
    value: PaymentStatus.FAILED,
  },
];

export const dateRangeDropdownOptions = [
  {
    name: 'Last month',
    value: DateRangeOptions.LAST_MONTH,
  },
  {
    name: 'Last 3 months',
    value: DateRangeOptions.LAST_3_MONTHS,
  },
  {
    name: 'Last 6 months',
    value: DateRangeOptions.LAST_6_MONTHS,
  },
  {
    name: 'Last 12 months',
    value: DateRangeOptions.LAST_12_MONTHS,
  },
  {
    name: 'Current financial year',
    value: DateRangeOptions.CURRENT_FINANCIAL_YEAR,
  },
  {
    name: 'Previous financial year',
    value: DateRangeOptions.PREVIOUS_FINANCIAL_YEAR,
  },
  {
    name: 'Custom date range',
    value: DateRangeOptions.CUSTOM_DATE_RANGE,
  },
];

export const commissionDateRangePickerSlotProps: DesktopDateRangePickerSlotProps<Dayjs, false> &
  MobileDateRangePickerSlotProps<Dayjs, false> = { 
  actionBar: {
    actions: ['cancel', 'accept'],
  },
  popper: {
    sx: {
      borderRadius: `8px`,
      color: '#2D2D2D',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'stretch',
      alignItems: 'flex-start',
      backgroundColor: '#FFFFFF',
      position: 'absolute',
      top: '50% !important',
      left: '50% !important',
      transform: 'translate(-50%, -50%) !important',
      outline: 'none',
      zIndex: '1600',
    },
  },
};

export const PAYOUT_TABLE_COLUMN_WIDTHS = {
  PERIOD: {
    width: '300px',
    minWidth: '200px',
    maxWidth: '300px',
  },
  TOTAL_AMOUNT: {
    width: '200px',
    minWidth: '150px',
    maxWidth: '200px',
  },
  PAYMENT_STATUS: {
    width: '200px',
    minWidth: '150px',
    maxWidth: '200px',
  },
  UPLOAD_INVOICE: {
    width: '200px',
    minWidth: '150px',
    maxWidth: '200px',
  },
  INVOICE_WORKING: {
    width: '200px',
    minWidth: '150px',
    maxWidth: '200px',
  },
};

export const INVOICE_WORKING_TABLE_COLUMN_WIDTHS = {
  NAME: {
    width: '280px',
    minWidth: '200px',
    maxWidth: '280px',
  },
  TYPE: {
    width: '280px',
    minWidth: '120px',
    maxWidth: '280px',
  },
  DATE: {
    width: '174px',
    minWidth: '150px',
    maxWidth: '174px',
  },
  DEAL_VALUE: {
    width: '180px',
    minWidth: '120px',
    maxWidth: '180px',
  },
  COMMISSION_RATE: {
    width: '140px',
    minWidth: '120px',
    maxWidth: '140px',
  },
  COMMISSION_EARNED: {
    width: '164px',
    minWidth: '120px',
    maxWidth: '164px',
  },
};
